<template>
  <div
    class="container flex md:mx-auto mx-0 flex-col md:flex-row mt-6 justify-center"
  >
    <div class="bg-white rounded p-8 text-center">
      <!-- image -->
      <div align="center" class="mb-6">
        <img :src="loadAppIcon()" class="w-40 rounded-lg" />
      </div>

      <!-- app name -->
      <div class="font-bold text-xl mb-4">
        <span v-if="appInformation.displayName.type === 'text'">
          {{ appInformation.displayName.value }}
        </span>
        <span v-else>
          {{ $t(`integrations.apps.${appName}.displayName`) }}
        </span>
      </div>

      <!-- app description -->
      <div class="mb-2">
        <span v-if="appInformation.description.type === 'text'">
          {{ appInformation.description.value }}
        </span>
        <span v-else>
          {{ $t(`integrations.apps.${appName}.description`) }}
        </span>
      </div>

      <!-- unsupported app error -->
      <div v-if="!appInformation.knownApp" class="text-r-error">
        {{ $t("integrations.apps.unknownAppError") }}
      </div>

      <!-- unexpected redirect error -->
      <div
        v-if="
          appInformation.expectedRedirect &&
          appInformation.expectedRedirect !==
            oauthGrantRequestParams.redirectUri
        "
        class="text-r-error"
      >
        {{ $t("integrations.apps.unexpectedRedirect") }}
      </div>

      <!-- buttons -->
      <div class="flex flex-row justify-center mt-4">
        <!-- grant access -->
        <r-button
          class="mx-2"
          @click="redirectWithCustomToken"
          :loading="loading"
        >
          {{ $t("buttons.authorize") }}
        </r-button>

        <!-- cancel and go back to home -->
        <r-button class="mx-2" text color="black" @click="$router.push('/')">
          {{ $t("buttons.cancel") }}
        </r-button>
      </div>
    </div>
  </div>
</template>

<script>
import integrationMap from "@/assets/configs/integrations.json"
import { mapGetters } from "vuex"

/**
 * Define the application grant access page
 */
export default {
  // component state
  data() {
    return {
      loading: false
    }
  },

  // calcualted props
  computed: {
    // spread store values
    ...mapGetters({
      // grant values
      oauthGrantRequestParams: "auth/getOauthGrantRequestParams",

      // auth user
      user: "auth/getUser",

      // userdoc attribute
      userDoc: "users/getDoc"
    }),

    /**
     * Founded integrations object
     * from intgerationMap
     */
    appName() {
      // get target app domain based on redirect
      const targetDomain = (
        this.oauthGrantRequestParams?.redirectUri || ""
      ).split("/")[2]

      // found matching integration
      const foundIntegration = Object.keys(integrationMap).find(
        (integrationKey) => {
          return integrationMap[integrationKey].domain === targetDomain
        }
      )

      // return integration key
      return foundIntegration || "unknown"
    },

    /**
     * extract the app information based on known integrations
     * and values.
     */
    appInformation() {
      return (
        integrationMap[this.appName] || {
          ...integrationMap.unknown
        }
      )
    }
  },

  // component functions
  methods: {
    /**
     * Returns the app icon
     */
    loadAppIcon() {
      const images = require.context(
        "../../assets/icons/integrations",
        false,
        /\.(png|svg|jpg|jpeg)$/
      )
      return images("./" + this.appInformation.iconName)
    },

    /**
     * Execute redirect with custom token
     */
    async redirectWithCustomToken() {
      this.loading = true
      if (this.appInformation.domain === "zapier.com") {
        const p1 = this.$store.dispatch("orgs/update", {
          id: this.userDoc.orgs[0],
          data: {
            zapier: {
              [this.userDoc.id]: this.user.uid
            }
          }
        })

        const p2 = this.$store.dispatch("users/update", {
          id: this.userDoc.id,
          data: {
            zapier: {
              [this.userDoc.orgs[0]]: this.user.uid
            }
          }
        })

        await Promise.all([p1, p2])
      }
      await this.$store.dispatch("auth/redirectWithCustomToken", {
        ...this.oauthGrantRequestParams,
        user: this.user
      })

      this.loading = false
    }
  },

  /**
   * Remove grant access data
   */
  beforeDestroy() {
    this.$store.commit("auth/setOauthGrantRequestParams", {})
  }
}
</script>
